import { Component } from '@angular/core';
import { CaseState } from '../_types/case-state';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { CasesStatesService } from '../_services/cases-states.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { CasesModesService } from '../../cases/_services/cases-modes.service';

@Component({
    selector: 'app-cases-states-list',
    templateUrl: './cases-states-list.component.html',
    styleUrls: ['./cases-states-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class CasesStatesListComponent {
  public casesStates: CaseState[] = [];
  public caseModes: any[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private casesStatesService: CasesStatesService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private casesModesService: CasesModesService
  ) {

  }

  async ngOnInit() {
    this.topbarService.setTitle("Estados de expediente");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({} as CaseState);
    });
    await this.loadCaseModes();
    this.allowWrite = true;//this.loginService.hasPermission("PROVIDERS_WRITE")
    this.allowDelete = true;//this.loginService.hasPermission("PROVIDERS_DELETE")
  }

  async loadCaseModes() {
    //sin sort, por decision expresa: cases_modes no tiene columna de orden, y ordenar por
    //nombre cambiaria el orden de los switches y las columnas respecto al que hay hoy
    let response = await firstValueFrom(this.casesModesService.all());
    this.caseModes = response.data;
  }

  /** Un estado está disponible en un modo si existe la fila de relación; sin fila, no lo está. */
  public hasCaseMode(caseState: any, caseModeId: string): boolean {
    return (caseState.caseModes ?? []).some((relation: any) => relation.caseModeId == caseModeId);
  }

  public async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows },
      include: ['caseModes']
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.casesStatesService.all(params));
    this.casesStates = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(caseState: CaseState) {
    this.router.navigate(['casesStates/' + (caseState && Object.keys(caseState).length > 0 ? caseState.id : 0)]);
  }

  delete(caseState: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el estado de expediente?",
        header: "Eliminar estado de expediente",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.casesStatesService.delete(caseState.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Estado de expediente eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }
}
